import { render, staticRenderFns } from "./complaint-info.vue?vue&type=template&id=bfacae68&scoped=true&"
import script from "./complaint-info.vue?vue&type=script&lang=js&"
export * from "./complaint-info.vue?vue&type=script&lang=js&"
import style0 from "./complaint-info.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./complaint-info.vue?vue&type=style&index=1&id=bfacae68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfacae68",
  null
  
)

export default component.exports